import styled from 'styled-components';
import { colors } from "colors";

export const Wrapper = styled.div`
  background-color: #f7f7f7;
  height: 100vh;
  display: flex;
`;

export const InnerWrapper = styled.div`
  margin: 0 auto;
  padding: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  padding: 64px 128px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 1px 1px 8px 2px lightgray;
  display: flex;
  flex-direction: column;
`;

export const Logo = styled.img`
  height: 48px;
  margin: 32px;
`;

export const WelcomeWrapper = styled.p`
  text-align: center;
  font-size: 20px;
  margin: 0;
`;

export const TextWrapper = styled.p`
  text-align: center;
  font-size: 14px;
  max-width: 320px;
  color: ${colors.charcoalGrey};
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
`;

export const InputWrapper = styled.input`
  padding: 10px;
  border: 1px solid lightgray;
  border-radius: 2px;
  
  ::placeholder {
    color: lightgrey;
    font-size: 14px;
  }
`;

export const ButtonWrapper = styled.button`
  height: 48px;
  width: 240px;
  text-align: center;
  border-radius: 24px;
  
  background-image: linear-gradient(260deg, #00aeff, #0076ff);
    color: ${colors.white};
    border: 0;
    svg {
      fill: ${colors.white};
    }

  padding: 16px 64px;
  font-weight: 600;
  flex: 0 0 auto;
  align-self: center;
  cursor: pointer;
  white-space: nowrap;
  align-items: center;
  outline: none;
`;
